import { ACTION_TYPES } from '@/actions';
import { judgeHasNextPage, getPagingList } from "@/core/util";

const INIT_STATE = {
  searchParams: {},
  hasMore: true,
  records: []
};

export default function searchProd(state = INIT_STATE, action) {
  let result = { ...state };
  const { type, payload } = action;
  switch (type) {
    // 清除搜索产品结果
    case ACTION_TYPES.CLAER_SEARCH_PROD_LIST:
      result.hasMore = INIT_STATE.hasMore;
      result.records = INIT_STATE.records;
      break;
    // 获取搜索产品结果列表(分页)
    case ACTION_TYPES.GET_SEARCH_PROD_PAGING_LIST:
      result.searchParams = {
        orderBy: 0,
        ...payload.searchParams
      };
      result.hasMore = judgeHasNextPage(payload);
      result.records = getPagingList(result.records, payload);
      break;
    default:
      result = state;
  }
  return result;
}
